//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Routing.js";
import "../no/NXObject.js";
let d=[[[0,"Definition",0,0],[0,"EndOfPath",0,"Routing.ControlPoint",0],[0,"EndPointOfOverstock",0,"Point",0],[0,"MidPointOfOverstock",0,"Point",0],[0,"StartOfPath",0,"Routing.ControlPoint",0],[0,"StartPointOfOverstock",0,"Point",0]],[[["number_of_segments"],"GetSegments",{R_:{segments:"Routing.ISegment[]"}},0,0],[["number_of_cross_sections"],"GetCrossSections",{R_:{cross_sections:"Curve[]"}},0,0],[["number_of_covered_stocks"],"GetCoveredStocks",{R_:{covered_stocks:"Routing.Stock[]"}},0,0],[["covered_stocks"],"SetCoveredStocks",{},1,0],[["number_of_overstocks"],"GetOverstocks",{R_:{overstocks:"Routing.Overstock[]"}},0,0],[[],"GetStartParameter",{R_:{start_offset:''}},0,0],[[],"GetEndParameter",{R_:{end_offset:''}},0,0]],[]];
SPLM.Routing.OverstockApplication = class extends SPLM.NXObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Routing.OverstockApplication";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;